module.exports = __webpack_public_path__ + "img/nuvola_4.75954ebb.png";